
// import React, { useState } from "react";
// import {
//     Box,
//     Typography,
//     TextField,
//     Button,
//     Paper,
//     Alert,
//     MenuItem,
//     FormControl,
//     InputLabel,
//     Select,
// } from "@mui/material";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";

// const ContactSection = () => {
//     const [formSubmitted, setFormSubmitted] = useState(false);
//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         mobile: "",
//         course: "",
//         mode: "",
//         message: "",
//     });

//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             const response = await fetch(`${process.env.REACT_APP_API_URL}/feedback`, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(formData),
//             });

//             if (response.ok) {
//                 setFormSubmitted(true);
//                 setFormData({
//                     name: "",
//                     email: "",
//                     mobile: "",
//                     course: "",
//                     mode: "",
//                     message: "",
//                 });
//                 e.target.reset(); // Clear the form fields in the UI

//                 // Hide the success message after 3 seconds
//                 setTimeout(() => setFormSubmitted(false), 3000);
//             } else {
//                 throw new Error("Failed to send message");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//             alert("Failed to send message. Please try again.");
//         }
//     };

//     return (
//         <Box
//             component="section"
//             sx={{
//                 bgcolor: "#f9f9f9",
//                 py: 8,
//                 px: 2,
//                 minHeight: "100vh",
//                 fontFamily: "'Poppins', sans-serif",
//             }}
//         >
//             <Typography
//                 variant="h4"
//                 align="center"
//                 sx={{ fontWeight: "bold", mb: 4, color: "#333" }}
//             >
//                 Contact Us
//             </Typography>

//             <Paper
//                 elevation={4}
//                 sx={{
//                     maxWidth: 600,
//                     mx: "auto",
//                     p: 4,
//                     borderRadius: 4,
//                     backgroundColor: "#ffffff",
//                 }}
//             >
//                 <form onSubmit={handleFormSubmit}>
//                     <TextField
//                         fullWidth
//                         name="name"
//                         label="Full Name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         required
//                         margin="normal"
//                         variant="outlined"
//                     />
//                     <TextField
//                         fullWidth
//                         name="email"
//                         label="Email"
//                         type="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                         margin="normal"
//                         variant="outlined"
//                     />
//                     <TextField
//                         fullWidth
//                         name="mobile"
//                         label="Phone Number"
//                         type="tel"
//                         value={formData.mobile}
//                         onChange={handleChange}
//                         required
//                         margin="normal"
//                         variant="outlined"
//                     />

//                     <FormControl fullWidth margin="normal" required>
//                         <InputLabel>Interested Course</InputLabel>
//                         <Select
//                             name="course"
//                             value={formData.course}
//                             onChange={handleChange}
//                             label="Interested Course"
//                         >
//                             <MenuItem value="MERN Stack">MERN Stack</MenuItem>
//                             <MenuItem value="Data Science">Data Science</MenuItem>
//                             <MenuItem value="Japanese Language">Japanese Language</MenuItem>
//                             <MenuItem value="Other">Other</MenuItem>
//                         </Select>
//                     </FormControl>

//                     <FormControl fullWidth margin="normal" required>
//                         <InputLabel>Preferred Mode</InputLabel>
//                         <Select
//                             name="mode"
//                             value={formData.mode}
//                             onChange={handleChange}
//                             label="Preferred Mode"
//                         >
//                             <MenuItem value="Online">Online</MenuItem>
//                             <MenuItem value="Offline">Offline</MenuItem>
//                             <MenuItem value="Hybrid">Hybrid</MenuItem>
//                         </Select>
//                     </FormControl>

//                     <TextField
//                         fullWidth
//                         name="message"
//                         label="Your Message"
//                         multiline
//                         rows={4}
//                         value={formData.message}
//                         onChange={handleChange}
//                         required
//                         margin="normal"
//                         variant="outlined"
//                     />

//                     <Button
//                         type="submit"
//                         variant="contained"
//                         fullWidth
//                         sx={{
//                             mt: 3,
//                             py: 1.5,
//                             fontWeight: "bold",
//                             textTransform: "none",
//                             bgcolor: "#d4a373",
//                             "&:hover": {
//                                 bgcolor: "#bf7832",
//                             },
//                         }}
//                     >
//                         Send Message
//                     </Button>

//                     {formSubmitted && (
//                         <Alert severity="success" sx={{ mt: 3 }}>
//                             Thank you for your message! We’ll get back to you shortly.
//                         </Alert>
//                     )}
//                 </form>
//             </Paper>

//             {/* WhatsApp Floating Button */}
//             <Box
//                 component="a"
//                 href="https://wa.me/919978572120?text=Hi%20there!%20I'm%20interested%20in%20your%20courses." // Replace with your number
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 sx={{
//                     position: "fixed",
//                     bottom: 16,
//                     right: 16,
//                     zIndex: 9999,
//                     bgcolor: "#25D366",
//                     borderRadius: "50%",
//                     width: 56,
//                     height: 56,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     boxShadow: 3,
//                     cursor: "pointer",
//                     "&:hover": {
//                         bgcolor: "#1ebea5",
//                     },
//                 }}
//             >
//                 <WhatsAppIcon sx={{ color: "#fff", fontSize: 30 }} />
//             </Box>
//         </Box>
//     );
// };

// export default ContactSection;

import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Alert,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    CircularProgress,
    Backdrop,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const ContactSection = () => {
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        course: "",
        mode: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/feedback`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setFormSubmitted(true);
                setFormData({
                    name: "",
                    email: "",
                    mobile: "",
                    course: "",
                    mode: "",
                    message: "",
                });
                e.target.reset();

                setTimeout(() => setFormSubmitted(false), 3000);
            } else {
                throw new Error("Failed to send message");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Failed to send message. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            component="section"
            sx={{
                bgcolor: "#f9f9f9",
                py: 8,
                px: 2,
                minHeight: "100vh",
                fontFamily: "'Poppins', sans-serif",
                position: "relative",
            }}
        >
            <Typography
                variant="h4"
                align="center"
                sx={{ fontWeight: "bold", mb: 4, color: "#333" }}
            >
                Contact Us
            </Typography>

            <Paper
                elevation={4}
                sx={{
                    maxWidth: 600,
                    mx: "auto",
                    p: 4,
                    borderRadius: 4,
                    backgroundColor: "#ffffff",
                }}
            >
                <form onSubmit={handleFormSubmit}>
                    <TextField
                        fullWidth
                        name="name"
                        label="Full Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        margin="normal"
                        variant="outlined"
                    />
                    <TextField
                        fullWidth
                        name="email"
                        label="Email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        margin="normal"
                        variant="outlined"
                    />
                    <TextField
                        fullWidth
                        name="mobile"
                        label="Phone Number"
                        type="tel"
                        value={formData.mobile}
                        onChange={handleChange}
                        required
                        margin="normal"
                        variant="outlined"
                    />

                    <FormControl fullWidth margin="normal" required>
                        <InputLabel>Interested Course</InputLabel>
                        <Select
                            name="course"
                            value={formData.course}
                            onChange={handleChange}
                            label="Interested Course"
                        >
                            <MenuItem value="MERN Stack">MERN Stack</MenuItem>
                            <MenuItem value="Data Science">Data Science</MenuItem>
                            <MenuItem value="Japanese Language">Japanese Language</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth margin="normal" required>
                        <InputLabel>Preferred Mode</InputLabel>
                        <Select
                            name="mode"
                            value={formData.mode}
                            onChange={handleChange}
                            label="Preferred Mode"
                        >
                            <MenuItem value="Online">Online</MenuItem>
                            <MenuItem value="Offline">Offline</MenuItem>
                            <MenuItem value="Hybrid">Hybrid</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        fullWidth
                        name="message"
                        label="Your Message"
                        multiline
                        rows={4}
                        value={formData.message}
                        onChange={handleChange}
                        required
                        margin="normal"
                        variant="outlined"
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={loading}
                        sx={{
                            mt: 3,
                            py: 1.5,
                            fontWeight: "bold",
                            textTransform: "none",
                            bgcolor: "#d4a373",
                            "&:hover": {
                                bgcolor: "#bf7832",
                            },
                        }}
                    >
                        Send Message
                    </Button>

                    {formSubmitted && (
                        <Alert severity="success" sx={{ mt: 3 }}>
                            Thank you for your message! We’ll get back to you shortly.
                        </Alert>
                    )}
                </form>
            </Paper>

            {/* Spinner Overlay */}
            <Backdrop
                sx={{ color: "#fff", zIndex: 1300 }}
                open={loading}
            >
                <CircularProgress size={60} thickness={5} />
            </Backdrop>

            {/* WhatsApp Floating Button */}
            <Box
                component="a"
                href="https://wa.me/918668617098?text=Hi%20there!%20I'm%20interested%20in%20your%20courses."
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    zIndex: 9999,
                    bgcolor: "#25D366",
                    borderRadius: "50%",
                    width: 56,
                    height: 56,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: 3,
                    cursor: "pointer",
                    "&:hover": {
                        bgcolor: "#1ebea5",
                    },
                }}
            >
                <WhatsAppIcon sx={{ color: "#fff", fontSize: 30 }} />
            </Box>
        </Box>
    );
};

export default ContactSection;
